module.exports = __webpack_public_path__ + "img/printer.9b2d05a7.svg";